import { Box, Container, Content } from 'react-bulma-components';

import React from 'react';

const SheetContainer = ({ title, children }) => {
  return (
      <Container >
        <Box>
          <Content>
            <h3 className="has-text-centered">{title}</h3>
            {children}
          </Content>
        </Box>
      </Container>
  )
}

export default SheetContainer;